import {IContactFormInquiryPayload} from "../api/add_contact_form_inquiry";

export interface ILandingContactFormValues {
    full_name: string;
    email: string;
    phone: string;
    message: string;
    /** Gate for submitting the form only — never sent to the API. */
    terms_accepted: boolean;
    bigdata_marketing_consent: boolean;
}

export const splitFullName = (fullName: string): {first_name: string; last_name: string} => {
    const trimmed = fullName.trim();
    const space = trimmed.indexOf(" ");

    if (space === -1) {
        return {first_name: trimmed, last_name: "—"};
    }

    return {
        first_name: trimmed.slice(0, space),
        last_name: trimmed.slice(space + 1).trim() || "—"
    };
};

export const normalizePhone = (phone: string): string => phone.replace(/\D/g, "").slice(-9);

export const buildContactInquiryPayload = (
    values: ILandingContactFormValues,
    includeMarketingConsent: boolean
): IContactFormInquiryPayload => {
    const {first_name, last_name} = splitFullName(values.full_name);

    return {
        email: values.email,
        first_name,
        last_name,
        message: values.message,
        phone: normalizePhone(values.phone),
        ...(includeMarketingConsent ? {bigdata_marketing_consent: values.bigdata_marketing_consent} : {})
    };
};
